












import { Component, Vue, Prop } from "../vue-ext";
import { HousingCompany } from "../models";
import "../components/LoginTopNav";

@Component
export default class HousingCompanyNotAvailableView extends Vue {
    private companyName: string;

    private created() {
        const company = this.root.getCurrentHousingCompany() as HousingCompany;

        if (company) {
            this.companyName = company.name;
        }
    }
}
